import React from 'react';
import {SocialIcon} from 'react-social-icons';
import {ReactSocialMediaIcons} from 'react-social-media-icons';

export function Footer() {

    return (
        <footer className="footer">
            <div className="footer-col">
                <p>CubeWraps © 2022</p>
                <div id="email">
                    <ReactSocialMediaIcons icon="mail" borderColor='transparent' backgroundColor='transparent'
                                           iconColor='#AFCA0B'/> info@cubewraps.scot
                </div>
                <div>
                    <ReactSocialMediaIcons icon="phone" borderColor='transparent' backgroundColor='transparent'
                                           iconColor='#AFCA0B'/> 01698 826946
                </div>
            </div>

            <div className="footer-col">
                <a href="https://cube.scot/about-us" className="link-light text-decoration-none">About Us</a>
                <a href="https://cube.scot/contact" className="link-light text-decoration-none">Contact Us</a>
            </div>

            <div className="footer-col" id="social_account">

                <div className='d-inline-flex align-items-center'>
                    <SocialIcon bgColor='transparent' fgColor='#AFCA0B'
                                url="https://www.linkedin.com/company/cube-wraps/"/>
                    <a href="https://www.linkedin.com/company/cube-wraps/" className="link-light text-decoration-none">
                        Linkedin
                    </a>
                </div>

                <div className='d-inline-flex align-items-center'>
                    <SocialIcon bgColor='transparent' fgColor='#AFCA0B' url="https://www.instagram.com/cubewraps/"/>
                    <a href="https://www.instagram.com/cubewraps/" className="link-light text-decoration-none">
                        Instagram
                    </a>
                </div>

                <div className='d-inline-flex align-items-center'>
                    <SocialIcon bgColor='transparent' fgColor='#AFCA0B' url="https://www.facebook.com/Cubewrapsscot"/>
                    <a href="https://www.facebook.com/Cubewrapsscot" className="link-light text-decoration-none">
                        Facebook
                    </a>
                </div>
            </div>

            <div className="footer-col">
                The Cube <br/>
                Argyle Crescent <br/>
                Hillhouse Industrial Estate <br/>
                Hamilton <br/>
                ML3 9BQ
            </div>
        </footer>
    )

}